import React from 'react';
import PropTypes from 'prop-types';
import { LinkButton } from 'sharedComponents';

const ProductLinkButton = ({ classes, viewOnly, onClick, buttonText, ...props }) => {
  if (viewOnly) return null;
  return (
    <LinkButton data-testid="button" onClick={onClick} className={classes.button} {...props}>
      {buttonText}
    </LinkButton>
  );
};

ProductLinkButton.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  viewOnly: PropTypes.bool,
  onClick: PropTypes.func,
};

ProductLinkButton.defaultProps = {
  classes: {},
  viewOnly: false,
  onClick: () => {},
};

export default ProductLinkButton;
